import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Link } from "react-router";

import * as workableActions from "../../modules/workable";
import style from "./Posting.css";

class Posting extends React.Component {
  async componentDidMount () {
    await this.props.getJobDetail(this.props.job.shortcode);
  }

  render () {
    const { job, jobDetail } = this.props;
    let location = `${job.location.telecommuting ? "Remote" : job.location.city}, ${job.location.country}`;
    if (job.id === "15702c"){
      location = "All Markets";
    }

    return (
      <div>
        <div className={style.hero}>
          <div className={style.content}>
            <div className={style.heroRow}>
              <div className={style.heroContent}>
                <h2 className={style.title}>{job.title}</h2>
                <div className={style.location}>{location}</div>
              </div>
            </div>
          </div>
        </div>
        <div className={style.content}>
          <div className={style.row}>
            <div className={style.workable}>
              <div dangerouslySetInnerHTML={{ __html: jobDetail.full_description }} />
            </div>
            <div className={style.actions}>
              <a
                className={style.apply}
                href={this.props.jobDetail.application_url}
                target={"_blank"}
                rel={"noopener noreferrer"}
              >
                Apply
              </a>
              <Link
                className={style.link}
                to={"/openings/"}>
                View all open positions
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Posting.propTypes = {
  job: PropTypes.object.isRequired,
  jobDetail: PropTypes.object.isRequired,
  getJobDetail: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  jobDetail: state.workable.jobDetail
});

const actions = {
  getJobDetail: workableActions.getJobDetail
};

const PostingContainer = connect(mapStateToProps, actions)(Posting);

export default PostingContainer;



// WEBPACK FOOTER //
// ./component/Posting/index.js